import { AccountingEntity } from "../../entity/AccountingEntity";
import { Accounting } from "../../gateway/Accounting/Accounting";
import { RolesUtils } from "../../utils/roles/roles";
import { Events } from "./Events/Events";
import { RequestAnalysisPlus } from "./RequestActiveAnalysisPlus/RequestActiveAnalysisPlus";
import { activateAnalysisPlusDialogTemplate } from "../../views/accounting/company/dashboards/dashboards.dialog-templates";

export class CompanyLicenseAnalysisPlusChange {
    Accounting = new Accounting();
    Events = new Events();
    callback = async () => {};
    constructor({ DSNDialogService, $mdDialog, toast, AccountingPlanService }) {
        this.DSNDialogService = DSNDialogService;
        this.$mdDialog = $mdDialog;
        this.toast = toast;
        this.AccountingPlanService = AccountingPlanService;
        this.RequestAnalysisPlus = new RequestAnalysisPlus({
            DSNDialogService: this.DSNDialogService,
            mdDialog: $mdDialog,
            toast: toast
        });
    }

    async execute(input, callback) {
        const { company, $event, accountingData } = input;
        this.callback = callback;
        const accounting = await this.Accounting.getById(accountingData._id);
        const accountingEntity = AccountingEntity.restore(accounting);
        if (
            !this.AccountingPlanService.features["AnalysisPlus"] &&
            !accountingEntity.props.plan?.analysisPlus?.limit
        ) {
            this.RequestAnalysisPlus.onOpenDialogRequestAnalysisPlusPlan(
                accountingEntity,
                () => {
                    this.callback({
                        response: {
                            message:
                                "Funcionalidade disponível apenas para Análise Plus."
                        },
                        status: false
                    });
                }
            );

            return;
        }
        const analysisPlusDisabled = this.analysisPlusDisabled({
            company,
            accountingData
        });
        if (analysisPlusDisabled?.isNotEnabled === true) return;
        if (analysisPlusDisabled?.isCannotAdminAnalysisPlus === false) {
            this.onActivateLicensesAnalysisPlus({});
            return;
        }
        const companyData = {
            _id: company._id,
            status: company.status,
            analytics: { analysisPlus: company.analysisPlus }
        };
        accountingEntity.setIsAnalysisPlusWithCompany(
            companyData,
            this.AccountingPlanService.features["AnalysisPlus"]
        );
        const analysisPlus = company.analysisPlus || {
            status: false
        };
        if (analysisPlus.status)
            this.deactivateAnalysisPlus(company, $event, accountingData);
        else {
            const excedeLimit =
                accountingEntity.props.plan?.analysisPlus?.limit ===
                accountingEntity.props.plan?.analysisPlus?.companies?.length;
            if (excedeLimit) {
                this.RequestAnalysisPlus.onOpenDialogRequestAnalysisPlusPlan(
                    accountingEntity,
                    () => {
                        this.callback({
                            response: {
                                message:
                                    "Funcionalidade disponível apenas para Análise Plus."
                            },
                            status: false
                        });
                    }
                );
            } else {
                this.RequestAnalysisPlus.onOpenDialogRequestAnalysisPlus(
                    accountingEntity,
                    company,
                    (params) => {
                        if (params.response === "success") {
                            this.updateAnalysisPlus({
                                company,
                                status: true
                            });
                        }
                    }
                );
            }
        }
    }

    analysisPlusDisabled({ company, accountingData }) {
        if (company.status != "ATIVO")
            return {
                disabled: true,
                message: "accounting",
                isNotEnabled: true
            };
        const analysisPlus = company.analysisPlus || {
            status: false
        };
        const isAdminUser = RolesUtils.userIsInRole({
            roles: ["Contabilidade"]
        });
        let isSuperUser = RolesUtils.userIsInRole({ roles: ["Super"] });
        if (accountingData.status !== "ATIVO") {
            isSuperUser = RolesUtils.userIsInRole({
                roles: [
                    "Super",
                    "Sucesso",
                    "NuHacker",
                    "ChampionsLeads",
                    "Heads"
                ]
            });
        }
        if (isSuperUser) {
            return { disabled: false, message: "" };
        }
        const accountingAnalysisPlanLimit = !!accountingData?.plan?.analysisPlus
            ?.limit;
        if (accountingAnalysisPlanLimit && !isAdminUser)
            return {
                disabled: true,
                message: "activate",
                isCannotAdminAnalysisPlus: false
            };
        if (!analysisPlus.status && !isAdminUser)
            return { disabled: true, message: "activate", isAdminOnly: false };
        if (analysisPlus.status && !isSuperUser)
            return { disabled: true, message: "deactivate", isAdminOnly: true };
        return { disabled: false, message: "" };
    }

    onActivateLicensesAnalysisPlus(analysisPlus) {
        this.DSNDialogService.custom({
            clickOutsideToClose: true,
            controller: "ActivateAnalysisPlusDialoWarngCtrl",
            controllerAs: "$ctrl",
            locals: {
                hasAccountingAnalysisPlus: true,
                hasAnalaysisPlus: false,
                analysisPlus,
                width: "517px",
                title: "Ativar licenças Análise Plus",
                templateHtml: activateAnalysisPlusDialogTemplate
            },
            after: {
                hide: () => {}
            }
        });
    }

    deactivateAnalysisPlus(company, $event, accountingData) {
        this.Events.send("carteira.analiseplus.desativar");
        this.DSNDialogService.confirmation({
            targetEvent: $event,
            destructive: true,
            locals: {
                title: "Desativar Análise Plus",
                //description,
                actions: {
                    confirm: {
                        label: "Desativar",
                        action: () => {
                            this.updateAnalysisPlus({
                                company,
                                status: false,
                                accountingData
                            });
                            this.$mdDialog.hide();
                        }
                    },
                    cancel: {
                        label: "Cancelar",
                        action: () => {
                            this.$mdDialog.cancel();
                        }
                    }
                }
            },
            after: {}
        });
    }

    async updateAnalysisPlus({ company, status, accountingData }) {
        const response = await this.Accounting.updateAnalysisPlus({
            accountingId: accountingData._id,
            company: { _id: company._id, name: company.name, status }
        });
        this.callback({ response, status });
    }
}
